import gql from "graphql-tag";

const query = gql`
  query SourceThumbnailData($sourceId: ID) {
    sourceThumbnailData(sourceId: $sourceId) {
      thumbnailName
      timestamp
    }
  }
`;

export default sourceId => ({
  query,
  variables: { sourceId },
});
